export default __webpack_public_path__ + "static/media/staff_want.543e1ec7.png";